/**
 * Akunka Analytics — dataLayer event helper
 * ES5 compatible. Events wired to elements in Phase 2.
 */
(function() {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  var AkunkaAnalytics = {
    push: function(eventName, params) {
      var payload = { event: eventName };
      if (params && typeof params === 'object') {
        for (var key in params) {
          if (params.hasOwnProperty(key)) {
            payload[key] = params[key];
          }
        }
      }
      window.dataLayer.push(payload);
    },

    heroCtaClick: function(label) {
      this.push('hero_cta_click', { cta_label: label });
    },

    heroSecondaryClick: function(label) {
      this.push('hero_secondary_click', { cta_label: label });
    },

    videoPlay: function(videoTitle) {
      this.push('video_play', { video_title: videoTitle });
    },

    videoProgress: function(videoTitle, percent) {
      this.push('video_' + percent, { video_title: videoTitle, percent: percent });
    },

    cardFlip: function(cardIndex) {
      this.push('card_flip_' + cardIndex, { card_index: cardIndex });
    },

    productClickFromCard: function(productTitle) {
      this.push('product_click_from_card', { product_title: productTitle });
    },

    liliLinkClick: function(destination) {
      this.push('lili_link_click', { destination: destination });
    },

    redCoffeeWaitlistSubmit: function(email) {
      this.push('red_coffee_waitlist_submit', { method: 'email' });
    },

    addToCart: function(productTitle, variant, price) {
      this.push('add_to_cart', {
        product_title: productTitle,
        variant: variant,
        price: price
      });
    }
  };

  window.AkunkaAnalytics = AkunkaAnalytics;
})();
